import { AppFrontendRoutes } from '@deltasierra/frontend-routing-app-frontend';
import { AppRouter, ExternalFrontendRouter } from '@deltasierra/frontend-routing-core';
import React from 'react';
import { useConfig } from '../config';

/**
 * @deprecated Use useAppFrontendRouter instead
 * @returns The router
 */
export function useDeprecatedAppFrontendRouter(): ExternalFrontendRouter | null {
    const [config] = useConfig();

    const router = React.useMemo(() => {
        if (!config) {
            return null;
        }
        return new ExternalFrontendRouter(config.appFrontendUrl);
    }, [config]);

    return router;
}

export function useAppFrontendRouter(): AppRouter<AppFrontendRoutes> | null {
    const [config] = useConfig();

    const router = React.useMemo(() => {
        if (!config) {
            return null;
        }
        return new AppRouter<AppFrontendRoutes>(config.appFrontendUrl);
    }, [config]);

    return router;
}
